<template>
  <div class="Sinos">
        <div class="sino-main" id="sino-main-id" @click="SinoAkakuwab">
            <i class="far fa-bell SinoIcone"></i>
            <span class="ContadorAlarme"><center>{{ qtasMsgSinos }}</center></span>
        </div>

        <div id="sino-conteudo" class="sino-akakuwab">
            <div id="sino-conteudo-akanga-id" class="sino-conteudo-akanga" >
                <div class="sino-akanga-ab">Alertas - Baterias</div>
            </div>
            <div class="sino-conteudo-kwatiar">
                <div v-if="!haMsg">
                    <b-img-lazy
                        :src="require('../../assets/okSemAlarme.jpg')"
                        alt="Sem alertas no momento" 
                        class="sino-conteudo-aaniAsem"
                        id="sino-conteudo-aaniAsem-id">
                    </b-img-lazy>
                    <div class="sino-conteudo-kwatiar-info text-center">Não há nenhum alerta no momento!</div>
                </div>
                <div v-else>
                    <Notificacoes v-for="notificacoes in notificacoesPorPag" 
                        :key="notificacoes.id"
                        :notificacaoObj="notificacoes" 
                        v-on:apaga="apagaSinos"
                        v-on:lida="lidaSinos"
                        class="Sinos-notificacoes" 
                    />
                    <b-pagination 
                        class="Sinos-conteudo-kwatiar-pag"
                        v-model="currentPageSinos" 
                        pills 
                        :total-rows="qtasMsgSinos" 
                        :per-page="perPageSinos"
                        size="sm"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Sinos',
    components: {
        Notificacoes: () => import(/* webpackChunkName: "sinosNotificacao" */ "./notificacao"),
    },
    props: { },
    computed: {
        qtasMsgSinos: function () {
            return this.notificacoesObjeto.length
        },
        notificacoesPorPag() {
            const items = this.notificacoesObjeto;
            // Return somente as páginas necessárias de acordo com a paginação 
            return items.slice(
                (this.currentPageSinos - 1) * this.perPageSinos,
                this.currentPageSinos * this.perPageSinos
            )
        }
    },
    data: function() {
        return {
            akakuwab: false,
            clicouNosBotSinos: false,
            haMsg: false,
            perPageSinos: 5,
            currentPageSinos: 1,
            notificacoesObjeto: [
                {
                    id: '1-bat',
                    descricao: 'Baixa Tensão - Célula 1',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-empty',
                    cor: '#2e2d2c',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '2-bat',
                    descricao: 'SOC menor que 20%',
                    codigo: 'H201',
                    apelido: 'Bateria Galpão',
                    tipo: 'Informação',
                    icone: 'fas fa-car-battery',
                    cor: 'gold',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '3-bat',
                    descricao: 'Alta Tensão - Célula 1',
                    codigo: 'H45-1',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-full',
                    cor: '#008fac',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '4-bat',
                    descricao: 'Erro NTC - Célula 6',
                    codigo: 'H302-6',
                    apelido: 'Bateria Externa',
                    tipo: 'Erro',
                    icone: 'fas fa-exclamation-triangle',
                    cor: 'red',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '5-bat',
                    descricao: 'Atuação EVR - Baixa Temp.6',
                    codigo: 'H300-6',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-low',
                    cor: '#10c8e9',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '6-bat',
                    descricao: 'Atuação EVR - Alta Temp.2',
                    codigo: 'H301-2',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-high',
                    cor: 'orange',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '7-bat',
                    descricao: 'Baixa Tensão - Célula 1',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-empty',
                    cor: '#2e2d2c',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '8-bat',
                    descricao: 'SOC menor que 20%',
                    codigo: 'H201',
                    apelido: 'Bateria Galpão',
                    tipo: 'Informação',
                    icone: 'fas fa-car-battery',
                    cor: 'gold',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '9-bat',
                    descricao: 'Alta Tensão - Célula 1',
                    codigo: 'H45-1',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-full',
                    cor: '#008fac',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '10-bat',
                    descricao: 'Erro NTC - Célula 6',
                    codigo: 'H302-6',
                    apelido: 'Bateria Externa',
                    tipo: 'Erro',
                    icone: 'fas fa-exclamation-triangle',
                    cor: 'red',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '11-bat',
                    descricao: 'Atuação EVR - Baixa Temp.6',
                    codigo: 'H300-6',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-low',
                    cor: '#10c8e9',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '12-bat',
                    descricao: 'Atuação EVR - Alta Temp.2',
                    codigo: 'H301-2',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-high',
                    cor: 'orange',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '13-bat',
                    descricao: 'Baixa Tensão - Célula 1',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-empty',
                    cor: '#2e2d2c',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '14-bat',
                    descricao: 'SOC menor que 20%',
                    codigo: 'H201',
                    apelido: 'Bateria Galpão',
                    tipo: 'Informação',
                    icone: 'fas fa-car-battery',
                    cor: 'gold',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '15-bat',
                    descricao: 'Alta Tensão - Célula 1',
                    codigo: 'H45-1',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-full',
                    cor: '#008fac',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '16-bat',
                    descricao: 'Erro NTC - Célula 6',
                    codigo: 'H302-6',
                    apelido: 'Bateria Externa',
                    tipo: 'Erro',
                    icone: 'fas fa-exclamation-triangle',
                    cor: 'red',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '17-bat',
                    descricao: 'Atuação EVR - Baixa Temp.6',
                    codigo: 'H300-6',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-low',
                    cor: '#10c8e9',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '18-bat',
                    descricao: 'Atuação EVR - Alta Temp.2',
                    codigo: 'H301-2',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-high',
                    cor: 'orange',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '19-bat',
                    descricao: 'Baixa Tensão - Célula 1',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-empty',
                    cor: '#2e2d2c',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '20-bat',
                    descricao: 'SOC menor que 20%',
                    codigo: 'H201',
                    apelido: 'Bateria Galpão',
                    tipo: 'Informação',
                    icone: 'fas fa-car-battery',
                    cor: 'gold',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '21-bat',
                    descricao: 'Alta Tensão - Célula 1',
                    codigo: 'H45-1',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-full',
                    cor: '#008fac',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '22-bat',
                    descricao: 'Erro NTC - Célula 6',
                    codigo: 'H302-6',
                    apelido: 'Bateria Externa',
                    tipo: 'Erro',
                    icone: 'fas fa-exclamation-triangle',
                    cor: 'red',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '23-bat',
                    descricao: 'Atuação EVR - Baixa Temp.6',
                    codigo: 'H300-6',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-low',
                    cor: '#10c8e9',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '24-bat',
                    descricao: 'Atuação EVR - Alta Temp.2',
                    codigo: 'H301-2',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-high',
                    cor: 'orange',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '25-bat',
                    descricao: 'Baixa Tensão - Célula 1',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-empty',
                    cor: '#2e2d2c',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '26-bat',
                    descricao: 'SOC menor que 20%',
                    codigo: 'H201',
                    apelido: 'Bateria Galpão',
                    tipo: 'Informação',
                    icone: 'fas fa-car-battery',
                    cor: 'gold',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '27-bat',
                    descricao: 'Alta Tensão - Célula 1',
                    codigo: 'H45-1',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-full',
                    cor: '#008fac',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '28-bat',
                    descricao: 'Erro NTC - Célula 6',
                    codigo: 'H302-6',
                    apelido: 'Bateria Externa',
                    tipo: 'Erro',
                    icone: 'fas fa-exclamation-triangle',
                    cor: 'red',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '29-bat',
                    descricao: 'Atuação EVR - Baixa Temp.6',
                    codigo: 'H300-6',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-low',
                    cor: '#10c8e9',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '30-bat',
                    descricao: 'Atuação EVR - Alta Temp.2',
                    codigo: 'H301-2',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-high',
                    cor: 'orange',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '31-bat',
                    descricao: 'Baixa Tensão - Célula 1',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-empty',
                    cor: '#2e2d2c',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '32-bat',
                    descricao: 'SOC menor que 20%',
                    codigo: 'H201',
                    apelido: 'Bateria Galpão',
                    tipo: 'Informação',
                    icone: 'fas fa-car-battery',
                    cor: 'gold',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '33-bat',
                    descricao: 'Alta Tensão - Célula 1',
                    codigo: 'H45-1',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-full',
                    cor: '#008fac',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '34-bat',
                    descricao: 'Erro NTC - Célula 6',
                    codigo: 'H302-6',
                    apelido: 'Bateria Externa',
                    tipo: 'Erro',
                    icone: 'fas fa-exclamation-triangle',
                    cor: 'red',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '35-bat',
                    descricao: 'Atuação EVR - Baixa Temp.6',
                    codigo: 'H300-6',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-low',
                    cor: '#10c8e9',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '36-bat',
                    descricao: 'Atuação EVR - Alta Temp.2',
                    codigo: 'H301-2',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-high',
                    cor: 'orange',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '37-bat',
                    descricao: 'Baixa Tensão - Célula 1',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-empty',
                    cor: '#2e2d2c',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '38-bat',
                    descricao: 'SOC menor que 20%',
                    codigo: 'H201',
                    apelido: 'Bateria Galpão',
                    tipo: 'Informação',
                    icone: 'fas fa-car-battery',
                    cor: 'gold',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '39-bat',
                    descricao: 'Alta Tensão - Célula 1',
                    codigo: 'H45-1',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-battery-full',
                    cor: '#008fac',
                    datahora: '2020-01-12T16:20:31Z'
                },
                {
                    id: '40-bat',
                    descricao: 'Erro NTC - Célula 6',
                    codigo: 'H302-6',
                    apelido: 'Bateria Externa',
                    tipo: 'Erro',
                    icone: 'fas fa-exclamation-triangle',
                    cor: 'red',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '41-bat',
                    descricao: 'Atuação EVR - Baixa Temp.6',
                    codigo: 'H300-6',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-low',
                    cor: '#10c8e9',
                    datahora: '2020-01-12T04:20:31Z'
                },
                {
                    id: '42-bat',
                    descricao: 'Atuação EVR - Alta Temp.2',
                    codigo: 'H301-2',
                    apelido: 'Kinder DEV',
                    tipo: 'Alerta',
                    icone: 'fas fa-temperature-high',
                    cor: 'orange',
                    datahora: '2020-01-12T04:20:31Z'
                },
            ]
        }
    },
    watch: {
        notificacoesObjeto: function () {
            if(this.notificacoesObjeto.length > 0) this.haMsg = true;
                else this.haMsg = false;
        }
    },
    methods: {
        SinoAkakuwab() {
            this.akakuwab = !this.akakuwab;

            if (this.akakuwab) {
                const alvo = document.getElementById("sino-conteudo");
                alvo.classList.add("sino-akakuwab-esa");
                window.addEventListener('click', this.fecharSinoAkakuwab);
            } else {
                const alvo = document.getElementById("sino-conteudo");
                alvo.classList.remove("sino-akakuwab-esa");
                window.removeEventListener('click', this.fecharSinoAkakuwab);
            }
        },
        fecharSinoAkakuwab() {
            const alvo = document.getElementById("sino-conteudo");
            const botao = document.getElementById('sino-main-id');
            const cardNotificacao = document.getElementById('notificacao-id');

            const ClickDentro = alvo.contains(event.target);
            const ClickBotao = botao.contains(event.target);
            let ClickNotifica = false;
            if(cardNotificacao !== null) ClickNotifica = cardNotificacao.contains(event.target);

            if(event.target.classList.value !== 'page-link') {  //Executa se não clicou no botao da paginação
                if(!ClickBotao)   {  //so executa de clicou fora do botao
                    if(!ClickNotifica) { //So executa se clicou fora de alguma notificacao
                        if(!ClickDentro) {
                            //Se clicou fora efetua o fechamento do menu avatar
                            if(!this.clicouNosBotSinos) {
                                this.$emit('fechouJanela');
                                alvo.classList.remove("sino-akakuwab-esa");
                                this.akakuwab = false;
                                this.currentPageSinos = 1;
                                window.removeEventListener('click', this.fecharSinoAkakuwab);
                                } else {
                                this.clicouNosBotSinos = false;
                            }
                        }
                    }
                }
            }
        },
        apagaSinos(reqID) {
            this.clicouNosBotSinos = true;
            const pos = this.notificacoesObjeto.map(function(e) { return e.id; }).indexOf(reqID);
            this.notificacoesObjeto.splice(pos, 1);
            //Falta implementar as ações com o servidor
        },
        lidaSinos(reqID) {
            this.clicouNosBotSinos = true;
            const pos = this.notificacoesObjeto.map(function(e) { return e.id; }).indexOf(reqID);
            this.notificacoesObjeto.splice(pos, 1);
            //Falta implementar as ações com o servidor
        },
        initSinos(entrada) {
             if(entrada.length > 0) this.haMsg = true;
        }
    },
    mounted() {
        this.initSinos(this.notificacoesObjeto);
    }
}
</script>

<style>
.Sinos {
    position: relative;
    height: 50px;
    width: 50px;
}
.sino-main {
    height: 50px;
    width: 50px;
}
.Sinos:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
}
.SinoIcone {
    position: absolute;
    top: 13px;
    left: 5px;
    font-size:  25px;
    color: #008fac;
}
.ContadorAlarme {
    position: absolute;
    top: 3px;
    left: 15px;
    font-size: 11px;
    font-weight: bold;
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
    color: #000;
    background: #ffd618;
    width: 32px;
    border-radius: 20px;
}

/********************************************************************************* */
/* Tela Expansiva de alertas *******************************************************/
.sino-akakuwab {
    position: absolute;
    right: 5px;
    top: 52px;
    background-color: #fff;
    min-width: 290px;
    min-height: 400px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 6;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    overflow: hidden;
    text-align: left !important;

    visibility: hidden;
    opacity: 0;
    transition: visibility 0.5s, opacity 0.5s linear;
}

.sino-akakuwab-esa {
    visibility: visible;
    opacity: 1;
}
/* ***************************************************************/

/* Conteudo do cabeçalho do menu **********************************/
.sino-conteudo-akanga {
    background-image: url("../../assets/hion_18.png");
    background-color: #000;
    /*background-image: linear-gradient(to bottom right, #008fac , #004f5f);*/

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    /* Needed to position the navbar */
    position: relative;
    height: 100px;
    width: 290px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
.sino-akanga-ab {
    text-decoration: none;
    position: absolute;
    top: 35px;
    left: 65px;
    color: #fff;
    text-shadow: 0px 2px 2px #000000;
    font-family: "Play", sans-serif;
    font-size: 20px;
}
.sino-conteudo-kwatiar {
    position: relative;
    height: 300px;
    width: 290px;
}
.sino-conteudo-aaniAsem {
    height: 260px;
    width: 100%;
}
.sino-conteudo-kwatiar-info {
    text-decoration: none;
    color: #2e2d2c;
    font-family: "Play", sans-serif;
    font-size: 16px;
}
.Sinos-conteudo-kwatiar-pag {
    position: absolute;
    top: calc(100% - 25px);
    left: 50%;
    transform: translate(-50%, -50%);
}

/********************************************************************* */

/* MEDIA QUERY XS ******************************************************/
@media (max-width:575px) {
    .sino-akakuwab {
        right: -45px;
    }
}

</style>